import { UserFriendlyError } from "../../../../../common/utils/base_error";
import { ICreateSatisfacaoClienteUseCase } from "../../../presentation/useCases/create/create_satisfacao_cliente_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreateSatisfacaoClienteUseCase
 */

export class CreateSatisfacaoClienteUseCase implements ICreateSatisfacaoClienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async createSatisfacaoCliente(
    status: number,
    centroCusto: number,
    cliente: number | null,
    nomeCliente: string | null,
    data: Date | null,
    preencher: boolean,
  ): Promise<void> {
    if (preencher) {
      if (nomeCliente === null || nomeCliente.length === 0) {
        throw new UserFriendlyError('O campo cliente deve ser preenchido');
      }
    } else {
      if (cliente === null || cliente === 0) {
        throw new UserFriendlyError('O campo cliente deve ser preenchido');
      }
    }

    await this.repository.createSatisfacaoCliente(
      status,
      centroCusto,
      cliente,
      nomeCliente,
      data,
    );
  }
}
